<template src="./Home.component.html"></template>
<style type="text/css" src="./Home.component.css"></style>

<script>
import Video from "./../Video/Video.component";
import Header from "./../Header/Header.component";
import Banner from "./../Banner/Banner.component";
import About from "./../About/About.component";
import Services from "./../Services/Services.component";
import Footer from "./../Footer/Footer.component";
import Projects from "./../Projects/Projects.component";
import { ToggleBus } from "./../../main";

export default {
  name: "Home",
  components: {
    HeaderComponent: Header,
    BannerComponent: Banner,
    AboutComponent: About,
    ServicesComponent: Services,
    VideoComponent: Video,
    FooterComponent: Footer,
    ProjectsComponent: Projects
  },
  data() {
    return {
      activeLink: "Header",
      displayMenu: false,
      scrolled: false
    };
  },
  methods: {
    navigateTo(menu) {
      this.activeLink = menu;
      this.displayMenu = false;
    },
    handleScroll() {
      this.scrolled = window.scrollY > 0;
      if (this.scrolled === true && this.displayMenu === true) {
        this.displayMenu = false;
      }
    },
    closeMenu() {
      this.displayMenu = false;
    }
  },
  created() {
    ToggleBus.$on("toggle", () => {
      this.displayMenu = !this.displayMenu;
    });
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    ToggleBus.$off("toggle");
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Home.component.vue